"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constant = require("../Theme/constant");

var _Dot = _interopRequireDefault(require("./components/Dot"));

var _DotsWrapper = _interopRequireDefault(require("./components/DotsWrapper"));

var _ImageIndicator = _interopRequireDefault(require("./components/ImageIndicator"));

var _ImageIndicatorWrapper = _interopRequireDefault(require("./components/ImageIndicatorWrapper"));

var _default = {
  PropTypes: {
    theme: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    customProperties: _propTypes.default.object,
    LeftArrow: _propTypes.default.node,
    RightArrow: _propTypes.default.node,
    Dot: _propTypes.default.node,
    showArrows: _propTypes.default.bool,
    showDots: _propTypes.default.bool,
    children: _propTypes.default.node.isRequired,
    cardsToShow: _propTypes.default.number,
    afterSlide: _propTypes.default.func,
    beforeSlide: _propTypes.default.func,
    infinite: _propTypes.default.bool,
    responsive: _propTypes.default.arrayOf(_propTypes.default.shape({
      breakPoint: _propTypes.default.number,
      cardsToShow: _propTypes.default.number
    })),
    padding: _propTypes.default.string,
    margin: _propTypes.default.string,
    hideArrowsOnNoSlides: _propTypes.default.bool,
    DotsWrapper: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),
    expandCarouselArrowClickableArea: _propTypes.default.bool,
    ImageIndicator: _propTypes.default.node,
    ImageIndicatorWrapper: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),
    showImageIndicator: _propTypes.default.bool
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    customProperties: {},
    showDots: true,
    showArrows: true,
    Dot: /*#__PURE__*/_react.default.createElement(_Dot.default, null),
    DotsWrapper: _DotsWrapper.default,
    ImageIndicator: /*#__PURE__*/_react.default.createElement(_ImageIndicator.default, null),
    ImageIndicatorWrapper: _ImageIndicatorWrapper.default,
    cardsToShow: null,
    afterSlide: null,
    beforeSlide: null,
    infinite: true,
    responsive: null,
    padding: '0px 0px',
    margin: '0px',
    hideArrowsOnNoSlides: true,
    expandCarouselArrowClickableArea: false,
    showImageIndicator: false
  }
};
exports.default = _default;